import { useEffect, useState } from "react";
import { apiFetch } from "../../api/Api";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export default function WorkerList() {
  const [workers, setWorkers] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false);

  // Fetch Workers
  const fetchWorkers = async () => {
    try {
      setLoading(true);
      const res = await apiFetch("leader_admin/get_all_workers");
      setWorkers(res.workers || []);
    } catch (error) {
      console.error("Error fetching workers:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkers();
  }, []);

  //  Edit Click
  const handleEdit = (worker) => {
    setEditId(worker.user_id);
    setEditData(worker);
  };

  // Handle Input Change
  const handleChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  //  Update Worker
  const handleUpdate = async (id) => {
    try {
      await apiFetch(`leader_admin/edit_user/${id}`, {
        method: "PUT",
        body: JSON.stringify(editData),
      });

      setEditId(null);
      fetchWorkers();
      if (editData.user_id === id) {
        alert("User profile updated successfully");
      } 
    } catch (error) {
      alert(error.message);
    }
  };

  //  Delete Worker
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this worker?")) return;

    try {
      await apiFetch(`leader_admin/delete_user/${id}`, {
        method: "DELETE",
      });

      fetchWorkers();
    } catch (error) {
      alert(error.message);
    }
  };

return (
  <DashboardLayout>
    <DashboardNavbar />

    <div className="container-fluid py-4" style={{ fontSize: "0.9rem" }}>

      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold mb-1" style={{ fontSize: "1.2rem" }}>
            कार्यकर्ता व्यवस्थापन / Worker Management
          </h4>
          <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
            आपल्या नेतृत्वाखालील सर्व कार्यकर्त्यांचे व्यवस्थापन करा /
            Manage all registered workers under your leadership panel
          </p>
        </div>

        <Button
          component={Link}
          to="/add_worker"
          variant="contained"
          sx={{
            fontSize: "0.8rem",
            background: "linear-gradient(45deg, #007bff, #00c6ff)",
            px: 3,
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            color: "#fff",
          }}
        >
          + कार्यकर्ता जोडा / Add Worker
        </Button>
      </div>

      {/* Card Container */}
      <div className="card shadow-sm border-0">
        <div className="card-body">

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <p className="mt-3 text-muted">
                कार्यकर्ते लोड होत आहेत... / Loading workers...
              </p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table align-middle table-hover" style={{ fontSize: "0.85rem" }}>
                <thead className="table-light">
                  <tr className="text-secondary">
                    <th>पूर्ण नाव / Name</th>
                    <th>ईमेल / Email</th>
                    <th>मोबाईल / Mobile</th>
                    <th>प्रभाग / Ward</th>
                    <th className="text-center">कृती / Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {workers.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-muted">
                        कोणतेही कार्यकर्ते आढळले नाहीत /
                        No workers found
                      </td>
                    </tr>
                  ) : (
                    workers.map((worker) => (
                      <tr key={worker.user_id}>
                        <td>
                          {editId === worker.user_id ? (
                            <input
                              type="text"
                              name="full_name"
                              value={editData.full_name}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                            />
                          ) : (
                            <span className="fw-semibold">
                              {worker.full_name}
                            </span>
                          )}
                        </td>

                        <td>
                          {editId === worker.user_id ? (
                            <input
                              type="email"
                              name="email"
                              value={editData.email}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                            />
                          ) : (
                            worker.email
                          )}
                        </td>

                        <td>
                          {editId === worker.user_id ? (
                            <input
                              type="text"
                              name="mobile"
                              value={editData.mobile}
                              onChange={handleChange}
                              className="form-control form-control-sm"
                            />
                          ) : (
                            worker.mobile
                          )}
                        </td>

                        <td>
                          <span className="badge bg-info text-dark">
                            {worker.ward_name} - प्रभाग क्र. {worker.ward_number}
                          </span>
                        </td>

                        <td className="text-center">
                          {editId === worker.user_id ? (
                            <>
                              <button
                                className="btn btn-success btn-sm me-2"
                                onClick={() =>
                                  handleUpdate(worker.user_id)
                                }
                              >
                                जतन करा / Save
                              </button>

                              <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => setEditId(null)}
                              >
                                रद्द करा / Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="btn btn-outline-primary btn-sm me-2"
                                onClick={() => handleEdit(worker)}
                              >
                                संपादन / Edit
                              </button>

                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() =>
                                  handleDelete(worker.user_id)
                                }
                              >
                                हटवा / Delete
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  </DashboardLayout>
);

}
